import { useMemo } from 'react'

import { useI18n } from '@runtime/core/i18n/i18n'
import TabbedCharacterHelpModal from '@/features/help/components/TabbedCharacterHelpModal'

type PuzzleHelpModalProps = {
  open: boolean
  onClose: () => void
  defaultTabId?: string
}

export default function PuzzleHelpModal({ open, onClose, defaultTabId }: PuzzleHelpModalProps) {
  const { t } = useI18n()

  const tabs = useMemo(
    () => [
      {
        id: 'overview',
        label: t('puzzle.help.how.tabs.overview'),
        content: t('puzzle.help.how.overview'),
      },
      {
        id: 'united',
        label: t('puzzle.help.how.tabs.united'),
        content: t('puzzle.help.how.united'),
      },
      {
        id: 'poster',
        label: t('puzzle.help.how.tabs.poster'),
        content: t('puzzle.help.how.poster'),
      },
      {
        id: 'posterSwitch',
        label: t('puzzle.help.how.tabs.posterSwitch'),
        content: t('puzzle.help.how.posterSwitch'),
      },
      {
        id: 'tips',
        label: t('puzzle.help.how.tabs.tips'),
        content: t('puzzle.help.how.tips'),
      },
    ],
    [t],
  )

  return (
    <TabbedCharacterHelpModal
      open={open}
      character="girl"
      title={t('puzzle.help.how.title')}
      tabs={tabs}
      onClose={onClose}
      defaultTabId={defaultTabId}
    />
  )
}
